import React from 'react';
const { getApiUrl } = require('../config/serverEndpoint');
export default function LegalLinks() {
 return <nav aria-label="Destek ve yasal bilgiler" className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-indigo-700">
  <a href={getApiUrl('/support')} target="_blank" rel="noopener noreferrer" className="underline">Destek</a>
  <a href={getApiUrl('/privacy')} target="_blank" rel="noopener noreferrer" className="underline">Gizlilik</a>
  <a href={getApiUrl('/terms')} target="_blank" rel="noopener noreferrer" className="underline">Koşullar</a>
  <a href={getApiUrl('/delete-account')} target="_blank" rel="noopener noreferrer" className="underline">Hesap silme talebi</a>
 </nav>;
}
